import { apiErrorList } from 'Services/restAdviser'
import { AxiosError } from 'axios'

/** Emit notifications for each error in an exception */
export const notifyError = (self: any, error: AxiosError): void => {
  const errorList = apiErrorList(error)

  errorList.forEach(error => self.$notify({
    group: 'global',
    title: 'Oops, ocorreu um problema',
    text: error,
    type: 'error',
  }))
}

export const notifySuccess = (self: any, message: string): void => {
  self.$notify({
    group: 'global',
    title: 'Sucesso',
    text: message,
    type: 'success',
  })
}

/** Emit notifications for each error in an exception */
export const notifyErrorSimpleString = (self: any, error: string[]): void => {
  const  { response } = [ error ].shift()

  self.$notify({
    group: 'global',
    title: 'Oops, ocorreu um problema',
    text: response.data.shift(),
    type: 'error',
  })
}

export default {
  notifyError,
  notifyErrorSimpleString,
  notifySuccess
}